import {Component, Input, OnInit} from '@angular/core';
import {ThumbnailableFileLink} from '../../services/api/api';
import {FileDummy} from './file-dummies';


declare type DummySize = 'LG' | 'XS' | undefined;

@Component({
  selector: 'app-file-dummy',
  templateUrl: './file-dummy.component.html',
  styleUrls: ['./file-dummy.component.scss'],
  standalone: false,
})
export class FileDummyComponent implements OnInit {
  fileDummy: FileDummy;
  loading: boolean;
  id: number;
  @Input() hover: boolean;
  @Input() dummySize: DummySize = 'LG';

  constructor() {
    this.id = Date.now();
    this.loading = true;
  }

  _draggedObj: any | undefined;

  get draggedObj(): any {
    return this._draggedObj;
  }

  @Input() set draggedObj(val: any) {
    this._draggedObj = val;
    if (this._draggedObj) {
      // && this._draggedObj.attachmentType) { // every object possible not just attachments
      this.resolveFileType();
    }
  }

  // TODO
  resolveSize(type: string): number {
    if (type) {
      if (type === 'width') {
        switch (this.dummySize) {
          case 'LG': {
            return 153;
          }
          case 'XS': {
            return 80;
          }
          default: {
            return 153;
          }
        }
      }
      if (type === 'height') {
        switch (this.dummySize) {
          case 'LG': {
            return 200;
          }
          case 'XS': {
            return 105;
          }
          default: {
            return 200;
          }
        }
      }
    }
  }

  resolveWrinklesSizes() {
    switch (this.dummySize) {
      case 'LG': {
        return 40;
      }
      case 'XS': {
        return 22;
      }
      default: {
        return 40;
      }
    }
  }

  resolveFileType() {
    this.fileDummy = new FileDummy(this.draggedObj);
    this.loading = false;
  }

  resolveThumbnailPreview(): boolean {
    if (this.draggedObj) {
      if (this.draggedObj.thumbnail) {
        return true;
      }
    }
    return false;
  }

  castThumbnailToString(thumbnail: ThumbnailableFileLink) {
    return thumbnail as unknown as string;
  }

  ngOnInit(): void {}
}
